<template>
    <div v-if="visible">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">{{title}}</strong></div>
            <div class="weui-dialog__bd">{{message}}</div>
            <div class="weui-dialog__ft">
                <template v-for="(button, index) in buttons">
                    <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" 
                        @click="click(index)"
                        :key="button.label">{{button.label}}</a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WeuiDialog",
    props: [
        'visible', // 是否可见
        'title',
        'message',
        'buttons'
    ],
    data: function() {
        return {}
    },
    methods: {
        click: function(index) {
            this.$emit('click');
            var button = this.buttons[index];
            if (button.url) {
                this.$router.push(button.url);
            }
            if (button.go) {
                this.$router.go(button.go)
            }
        }
    }
};
</script>
